<section [class]="'zn-gis-dashboard-card zn-gis-dashboard-card-' + group().tone">
  <header class="zn-gis-dashboard-card-header">
    <span class="zn-gis-dashboard-card-icon" aria-hidden="true">
      <i [class]="group().iconClass"></i>
    </span>
    <h2 class="zn-gis-dashboard-card-title">{{ group().title | abpLocalization }}</h2>
  </header>

  <div class="zn-gis-dashboard-card-items">
    @for (item of group().items; track item.key) {
      <button
        class="zn-gis-dashboard-card-item"
        [class.zn-gis-dashboard-card-item-link]="!isDisabled(item)"
        [class.zn-gis-dashboard-card-item-disabled]="isDisabled(item)"
        [class.zn-gis-dashboard-card-item-zero]="isZeroCount(item)"
        type="button"
        [disabled]="isDisabled(item)"
        (click)="onQuerySelected(item)"
      >
        <div class="zn-gis-dashboard-card-item-content">
          <span class="zn-gis-dashboard-card-label" [title]="item.label | abpLocalization">{{ item.label | abpLocalization }}</span>
        </div>

        <span class="zn-gis-dashboard-card-count" [title]="getCountLabel(item)">{{ getCountLabel(item) }}</span>
      </button>
    }
  </div>
</section>
